export default __webpack_public_path__ + "static/johanAudio-68f937053b74b6a6fa603dab63ea5c4a.mp3";